'use strict'

import _ from 'lodash';
import state from '../util/state';

const Dbtn = class {
  constructor(el) {
    this.DriveBtn();

    window.addEventListener('scroll', _.throttle(this.scrl, 500));

  }
  DriveBtn() {
    const body = document.querySelector('body'),
          dbtn = document.querySelector('.d-btn'),
          closeBtn = document.querySelector('.d-btn-close'),
          closeBg = document.querySelector('.d-contents_bg'),
          dcnt = document.querySelector('.d-contents');
    var open = false;

    if(state.dev === 'sp') {
      dcnt.style.height = window.innerHeight + 'px';
    }

    dbtn.onclick = function(e) {
      e.preventDefault();
      if(!open) {
        body.classList.add('fix');
        dcnt.classList.add('active');
      } else {
        body.classList.remove('fix');
        dcnt.classList.remove('active');
      }
      open = !open;
    }

    closeBtn.onclick = function(e) {
      e.preventDefault();
      if(open) {
        body.classList.remove('fix');
        dcnt.classList.remove('active');
        open = false;
      }
    }
    closeBg.onclick = function(e) {
      e.preventDefault();
      if(open) {
        body.classList.remove('fix');
        dcnt.classList.remove('active');
        open = false;
      }
    }
  }
  scrl() {
    const scroll = window.pageYOffset,
          footer = document.querySelector('footer.global'),
          dbtn = document.querySelector('.d-btn'),
          size = (state.dev === 'pc') ? 280 : 340;

    var clientRect = footer.getBoundingClientRect();
    var footerPos = clientRect.top - (window.innerHeight - size);

    if (scroll > 100 && footerPos > size) {
      dbtn.classList.add('active');
    } else {
      dbtn.classList.remove('active');
    }
  }
};
export default Dbtn;
